// Save as: src/components/SEO.js

import { Helmet } from 'react-helmet-async';

const SEO = ({ title, description, path = '/', noindex = false }) => {
  const siteUrl = 'https://barrack.ai';
  const fullUrl = `${siteUrl}${path}`;
  const siteName = 'Barrack AI';
  const ogImage = `${siteUrl}/og-image.png`;

  const fullTitle = path === '/' 
    ? title 
    : `${title} | ${siteName}`;

  // Organization schema — homepage only
  const orgSchema = {
    "@context": "https://schema.org",
    "@type": "Organization",
    "name": "Barrack AI",
    "url": "https://barrack.ai",
    "logo": "https://barrack.ai/logo512.png",
    "description": "GPU cloud platform with per-minute billing. Rent NVIDIA B300, B200, H200, H100, A100, and L40 GPUs on-demand.",
    "sameAs": [
      "https://twitter.com/barrackai",
      "https://blog.barrack.ai",
      "https://docs.barrack.ai"
    ]
  };

  // WebPage schema — every page
  const pageSchema = {
    "@context": "https://schema.org",
    "@type": "WebPage",
    "name": fullTitle,
    "description": description,
    "url": fullUrl,
    "isPartOf": {
      "@type": "WebSite",
      "name": "Barrack AI",
      "url": "https://barrack.ai"
    }
  };

  return (
    <Helmet>
      <title>{fullTitle}</title>
      <meta name="description" content={description} />
      <link rel="canonical" href={fullUrl} />
      {noindex ? <meta name="robots" content="noindex, nofollow" /> : <meta name="robots" content="index, follow" />}

      {/* Open Graph */}
      <meta property="og:type" content="website" />
      <meta property="og:url" content={fullUrl} />
      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={description} />
      <meta property="og:image" content={ogImage} />
      <meta property="og:image:width" content="1200" />
      <meta property="og:image:height" content="630" />
      <meta property="og:site_name" content={siteName} />

      {/* Twitter */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:url" content={fullUrl} />
      <meta name="twitter:title" content={fullTitle} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={ogImage} />
      <meta name="twitter:site" content="@barrackai" />

      {/* Structured Data */}
      {path === '/' && (
        <script type="application/ld+json">
          {JSON.stringify(orgSchema)}
        </script>
      )}
      <script type="application/ld+json">
        {JSON.stringify(pageSchema)}
      </script>
    </Helmet>
  );
};

export default SEO;
